import React from 'react'
import './maintenance.css'

const Maintenance = () => {
  return (
    <div className="maintenance-wrapper">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80">
            <circle cx="32" cy="32" r="30" stroke="#1890ff" strokeWidth="3" strokeDasharray="6 4"/>
            <path d="M32 18V36L40 42" stroke="#1890ff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="32" cy="32" r="3" fill="#1890ff"/>
          </svg>
        </div>
        <h1 className="maintenance-title">系统维护中</h1>
        <p className="maintenance-desc">
          尊敬的用户，您好！<br />
          系统正在进行维护升级，届时将暂停服务。<br />
          请稍后再来，感谢您的理解与支持！
        </p>
        <div className="maintenance-info">
          <span>如有紧急问题，请联系管理员</span>
        </div>
      </div>
    </div>
  )
}

export default Maintenance
